import React, { useCallback } from 'react'
import styled from 'styled-components'
import { useUpdateLog } from '../../../utils/log'
import CheckLine from '../items/CheckLine'
import { FormTitleProps } from '../items/FormTitle'
import BaseGroup from './BaseGroup'

/** AccordionGroupPropsのtype定義 */
type AccordionGroupProps = FormTitleProps & {
  /** 選択行の見出し */
  label: string
  /** アコーディオンの開閉状態 */
  isOpened: boolean
  /** 子要素 */
  children: React.ReactNode
  /** 子要素をマージンなしで配置する場合はtrueを指定 */
  noMargin?: boolean
  /** 開閉状態変更時のコールバック */
  onChanged: (isOpened: boolean) => void
}

/** アコーディオングループ */
const AccordionGroup: React.FC<AccordionGroupProps> = (props) => {
  /** チェックボタン押下時のイベント */
  const onCheckClick = useCallback(() => {
    if (!props.onChanged) {
      return
    }
    props.onChanged(!props.isOpened)
  }, [props.onChanged, props.isOpened])

  useUpdateLog(
    props.title,
    {
      title: props.title,
      isRequired: props.isRequired,
      isOpened: props.isOpened,
    },
    [props]
  )
  return (
    <BaseGroup
      isRequired={props.isRequired}
      title={props.title}
      description={props.description}
      hideTitle={props.hideTitle}
    >
      <CheckLine
        isChecked={props.isOpened}
        label={props.label}
        onClick={onCheckClick}
      />
      {props.isOpened && <ChildrenArea>{props.children}</ChildrenArea>}
    </BaseGroup>
  )
}

export default AccordionGroup

/** アコーディオン開いたときに表示するコンテンツのスタイル */
const ChildrenArea = styled.div`
  background: var(--color-background);
`
